
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/event/[eventId]/registrants",
      function () {
        return require("private-next-pages/admin/event/[eventId]/registrants.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/event/[eventId]/registrants"])
      });
    }
  